import { styled as p } from "@mui/material";
import a from "react-dom";
import { Tooltip as n } from "react-tooltip";
import { jsx as m } from "react/jsx-runtime";
const d = p(n)`
  --rt-opacity: 1;
  --rt-color-dark: #696c6e;

  font-size: 14px !important;
  font-weight: 300 !important;
  line-height: 20px !important;
  max-width: 300px;
  padding: 10px 20px !important;
  border-radius: 6px !important;
  z-index: 1301 !important; // mui popover is 1300
`, f = (t) => {
  const {
    stay: o,
    tooltipRef: r,
    ...i
  } = t, e = o ? {
    clickable: !0,
    delayHide: 1e3
  } : {};
  return a.createPortal(/* @__PURE__ */ m(d, {
    variant: "dark",
    ref: r,
    ...i,
    ...e
  }), document.body);
};
export {
  f as default
};
//# sourceMappingURL=ApeironTooltip.js.map
